import type { ListItem } from '@/components/Accordion';
import { useTranslation } from '@/utils/useTranslation';
import HelpPageLayout from '@/components/HelpPageLayout';
import { useGlobalContext } from '../GlobalProvider';

const Faqs = () => {
  const { programmeId = 'BAEC' } = useGlobalContext();

  const { t } = useTranslation(`${programmeId}/faqs`);

  const FAQs = t<Array<ListItem>>('FAQs', {
    returnObjects: true,
  });

  return (
    <HelpPageLayout
      title={t('title')}
      description={t('description')}
      list={FAQs}
      linkInListText={t('linkInListText')}
      linkInListUrl={t('linkInListUrl')}
      contactUsText={t('contactUsText')}
    />
  );
};

export default Faqs;
